/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'CREATE_INVITATION',
]);



// WEBPACK FOOTER //
// ./src/constants/InvitationConstants.js